import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../../lib/hoc/withModal';
import CsQnaQuestionModal from '../../../../../views/cs/qna/common/modal/CsQnaQuestionModal';
import { csQnaActions } from '../../../../../store/modules/cs/qna';

class CsInquiryQuestionModalContainer extends Component {
  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    this.props.toggleModal({
      name: ['csQnaQuestionModal'],
      isOpen: false,
      data: {},
    });
  };

  render() {
    return <CsQnaQuestionModal {...this.state} {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.csQna.csQnaQuestionModal.isOpen,
    data: state.csQna.csQnaQuestionModal.data,
  };
};

const mapDispatchToProps = {
  openCsQnaQuestionModal: csQnaActions.openCsQnaQuestionModal,
  setData: csQnaActions.setData,
  toggleModal: csQnaActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(CsInquiryQuestionModalContainer));
